/** @format */

import { BITCOINCASH_URL } from "../constants";
import { useLanguageContext } from "../context/LanguageContext";
import Footer from "../components/sections/Footer";
import { logo } from "../assets/icons";
import LanguageSelector from "../components/LanguajeSelector";
import RedirectButton from "../components/ui/RedirectButton"
import BackArrow from "../components/ui/BackArrow"
export default function AboutPage() {
  const { t } = useLanguageContext();
  async function copyTextToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {}
  }
  const textToCopy = `<iframe
      height="100%"
      width="100%"
      src="https://www.mapa.bcharg.com/"
      title="BitcoinCashArgentina Map"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
></iframe>`;
  return (
    <main className="text-white flex flex-col items-center gap-4 pb-20 p-4">
      <LanguageSelector/>
      <BackArrow />
      <div className="flex flex-row items-center gap-4 justify-center py-8 mx-40">
        <div className="h-32 w-32 flex items-center">
          {logo}
        </div>
        <h1 className="p-2 text-3xl  w-auto text-wrap">Bitcoin Cash</h1>
      </div>
      <p className="px-6 pb-4 max-w-[80ch]">{t("aboutPage", "hero", "description")}</p>

      <RedirectButton href={BITCOINCASH_URL} title={t("aboutPage", "hero", "buttonText")}/>
      <h1 className="p-2 mt-10 text-3xl">{t("aboutPage", "howToUse", "title")}</h1>
      <div className="border-2 p-1 border-gray-700 h-dvh max-h-[600px] w-full max-w-[700px]">
        <iframe
          height="100%"
          width="100%"
          src="/"
          title="BitcoinCash Map"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>

      <div className="bg-gray-900 text-white p-4 rounded-md w-full max-w-[700px] border border-gray-700">
        <div className="flex justify-between items-center mb-2">
          <span className="text-gray-400"></span>
          <button
            className="code bg-gray-800 hover:bg-gray-700 text-gray-300 px-3 py-1 rounded-md text-xs"
            onClick={() => copyTextToClipboard(textToCopy)}
          >
            Copy
          </button>
        </div>
        <code id="code">
          <p>
            &lt;<span className="text-[#C472DA]">iframe</span>
          </p>
          <p className="pl-4 text-[#C472DA]">
            <span className="text-[#4AC541]">height</span>=<span className="text-[#F0FA8C]">"100%" </span>
            <br />
            <span className="text-[#4AC541]">width</span>=<span className="text-[#F0FA8C]">"100%"</span> <br />
            <span className="text-[#4AC541]">src</span>=<span className="text-[#F0FA8C]">"https://www.mapa.bcharg.com/"</span> <br />
            <span className="text-[#4AC541]">title</span>=<span className="text-[#F0FA8C]">"BitcoinCash Map"</span>
            <br />
            <span className="text-[#4AC541]">frameborder</span>=<span className="text-[#F0FA8C]">"0"</span> <br />
            <span className="text-[#4AC541]">allow</span>=
            <span className="text-[#F0FA8C]">
              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            </span>{" "}
            <br />
            <span className="text-[#4AC541]">referrerpolicy</span>=<span className="text-[#F0FA8C]">"strict-origin-when-cross-origin"</span>
            <br />
            <span className="text-[#4AC541]">allowfullscreen</span> <br />
          </p>
          &gt;&lt;<span className="text-[#C472DA]">/iframe</span>&gt;
        </code>
      </div>

      <RedirectButton title={t("aboutPage", "footer", "button")}/>
      <Footer />
    </main>
  );
}
